import{BeanResposta} from './BeanResposta'


export class BeanPergunta{
  constructor(
    public pergIdCdPergunta  : string,
    public cateIdCdCategoria  : string,
    public pergDsPergunta  : string,
    public pergDsObservacao  : string,
    public pergDhInativo  : string,
    public answers  : BeanResposta,
    public pergNrOrdem   : string,
    public pergInExtra  : string,
    public pergInRespostasemlista  : string,
    
  ){}
}